// extracted by mini-css-extract-plugin
export default {"shake":"twoFactor_shake__+0xbd","progress":"twoFactor_progress__NfLVm"};